import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-12 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-8 text-center">Privacy Policy</h1>
        
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 sm:p-8 shadow-lg shadow-purple-900/30 border border-purple-500/20">
          <div className="space-y-6 text-gray-300">
            <div>
              <p className="text-gray-400 text-sm mb-6">Last Updated: January 2026</p>
              <p className="text-base leading-relaxed mb-4">
                Invotage ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">1. Information We Collect</h2>
              <p className="text-base leading-relaxed mb-3">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Name, email address, and contact information</li>
                <li>Company name and business details</li>
                <li>Project requirements and specifications</li>
                <li>Payment and billing information</li>
                <li>Communications between you and Invotage</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">2. How We Use Your Information</h2>
              <p className="text-base leading-relaxed mb-3">
                We use the information we collect to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Provide, maintain, and improve our services</li>
                <li>Process your transactions and send related information</li>
                <li>Send you technical notices, updates, and support messages</li>
                <li>Respond to your comments, questions, and customer service requests</li>
                <li>Communicate with you about products, services, and events</li>
                <li>Monitor and analyze trends, usage, and activities</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">3. Information Sharing and Disclosure</h2>
              <p className="text-base leading-relaxed mb-3">
                We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>With service providers who assist in our operations</li>
                <li>To comply with legal obligations or respond to lawful requests</li>
                <li>To protect the rights, property, or safety of Invotage, our clients, or others</li>
                <li>In connection with a merger, sale, or acquisition of all or part of our company</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">4. Data Security</h2>
              <p className="text-base leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">5. Your Rights</h2>
              <p className="text-base leading-relaxed mb-3">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-base">
                <li>Access and receive a copy of your personal information</li>
                <li>Correct or update your personal information</li>
                <li>Request deletion of your personal information</li>
                <li>Object to or restrict the processing of your information</li>
                <li>Withdraw consent where we rely on it</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">6. Cookies and Tracking Technologies</h2>
              <p className="text-base leading-relaxed">
                We use cookies and similar tracking technologies to track activity on our website and collect certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">7. Children's Privacy</h2>
              <p className="text-base leading-relaxed">
                Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children under 18.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">8. Changes to This Privacy Policy</h2>
              <p className="text-base leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">9. Contact Us</h2>
              <p className="text-base leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-gray-900/50 rounded-lg border border-purple-500/20">
                <p className="text-base"><strong className="text-white">Invotage</strong></p>
                <p className="text-base">11040 Santa Monica Blvd #310</p>
                <p className="text-base">Los Angeles, CA 90025</p>
                <p className="text-base mt-2">Email: info@invotage.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
